import React, { useEffect, useRef, useState } from 'react';
import Main from '../Main';
import { Col, Dropdown, Form, Modal, ProgressBar, Row } from 'react-bootstrap';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg'
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn, SBSaveUpdateBtn } from '../Buttons/Buttons';
import ComplaintEscalationTable from './ComplaintEscalationTable';
import Select from 'react-select';
import AddComplaintEsaclation from './AddComplaintEsaclation';
import Download from '../MainSection/Download/Download';
import { useLocation, useNavigate } from 'react-router-dom';
import ViewComplaints from './ViewComplaints';
import ComplaintValueFilterModal from './ComplaintValueFilterModal';
import ComplaintColumnFilterModal from './ComplaintColumnFilterModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadComplaintEscalationData, loadRoleBasedModulePermissionsData, loadSingleComplaintEscalationData, postComplaintEscalationDatas, postComplaintEscalationStatusChangeDatas } from '../../redux/action';
import { ADDED_BY_ID } from '../../Constants';
import * as HeaderAuthentication from '../HeaderAuthentication';
import { baseURL } from '../BaseUrl';
import moment from 'moment';
import AssignToComplaintModal from './AssignToComplaintModal';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';
import UpdateERT from './UpdateERT';

const statusOptions = [
    { value: 36, label: "Pending" },
    { value: 37, label: "In-Process" },
    { value: 38, label: "Resolved" },
    { value: 39, label: "Re-Open" },
    { value: 40, label: "Cancel" },
]
const ComplaintEscalation = () => {

    let dispatch = useDispatch();
    let location = useLocation();

    const { complainEscalationData } = useSelector((state) => state.data);
    const { singleComplaintEscalationData } = useSelector((state) => state.data);
    // const { modulePermissions } = useSelector((state) => state.data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Find the module data using the moduleId
            const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
            setModuleData(module);
        }
    }, [storedModulePermissions, moduleId]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [viewComplaintModal, setViewComplaintModal] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [files, setFiles] = useState([]);
    const [showAttachmentUploadModal, setShowAttachmentUploadModal] = useState(false);
    const [progress, setProgress] = useState([]);
    const [droppedFile, setDroppedFile] = useState(null);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showAssignToModal, setAssignToModal] = useState(false);
    const [showERTModal, setERTModal] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState([
        "SR NO", "TICKET TYPE", "DATE", "COMPANY", "REPORTED BY", "PLANT", "EMAIL", "CONTACT", "PRIORITY", "ASSIGNED TO", "ERT (In Days)", "ISSUE TYPE", "STATUS", "ACTION"
    ]);
    const [complaintId, setComplaintId] = useState("");
    const [searchText, setSearchText] = useState('');
    const [searchParams, setSearchParams] = useState('');
    const [statusID, setStatusID] = useState(null);
    const [ticketType, setTicketType] = useState(location.state?.ticketType || null);
    const [whereClause, setWhereClause] = useState('');

    const fileInputRef = useRef(null);
    // const { ticketType, statusId } = location.state || {};

    // useEffect(() => {
    //     getComplaintData()
    // }, [])

    // const getComplaintData = () => {
    //     dispatch(loadComplaintEscalationData(ticketType, statusId, searchText, setLoading))
    // }

    useEffect(() => {
        if (fromDate && toDate) {
            // Format the dates using moment.js
            const formattedFromDate = moment(fromDate).format('DD-MMM-YYYY'); // e.g., 01-Jan-2024
            const formattedToDate = moment(toDate).format('DD-MMM-YYYY');     // e.g., 31-Dec-2024

            // Build the whereClause with formatted dates
            const whereClause = `CONVERT(DATE,c.[Complaints_ReportedDate],101) >= CONVERT(DATE,'${formattedFromDate}',101) AND CONVERT(DATE,c.[Complaints_ReportedDate],101) <= CONVERT(DATE,'${formattedToDate}',101)`;

            // Update searchParams
            setSearchParams(whereClause);
        } else {
            setSearchParams(''); // Clear date filter when no dates are selected
        }
    }, [fromDate, toDate]); // Re-run when fromDate or toDate changes

    // Effect to fetch complaints based on searchText or date range
    useEffect(() => {
        setLoading(false); // Show loading spinner while fetching
        getComplaintData(); // Fetch complaints based on current searchParams
    }, [searchText, searchParams, statusID, ticketType]); // Fetch data on searchText or searchParams change

    // Function to fetch complaint data with optional searchText and date filters
    const getComplaintData = () => {
        const searchTextParam = searchText.trim(); // Trim any extra spaces
        // const ticketType = location.state?.ticketType || null; // Use ticketType from location.state
        const statusId = location.state?.statusId || statusID; // Use statusId from location.state    

        if (searchTextParam || searchParams || statusId || ticketType) {
            // If searchText or searchParams is present, fetch filtered data
            dispatch(loadComplaintEscalationData(ticketType, statusID, searchTextParam, searchParams, whereClause, setLoading));
        } else {
            // If no filters, fetch all data
            dispatch(loadComplaintEscalationData(null, null, null, '', '', setLoading));
        }
    };

    // Use the useEffect hook to set statusID from location.state when component mounts
    useEffect(() => {
        if (location.state && location.state.statusId) {
            setStatusID(location.state.statusId); // Set the statusID passed from the first component
        }
    }, [location.state]);

    useEffect(() => {
        dispatch(loadRoleBasedModulePermissionsData())
    }, [])

    const handleStatus = (selectedOption) => {
        setStatusID(selectedOption ? selectedOption.value : null);  // Assuming the value in the dropdown options is what you need.
    };

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleOpenModal = (compId) => {
        setIsModalOpen(true);
        if (compId) {
            dispatch(loadSingleComplaintEscalationData(compId));
            setComplaintId(compId);
        } else {
            setComplaintId("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenViewModal = (compId) => {
        // navigate('/complaint-history', { state: { complaintId: compId } });
        navigate(`/complaint-history/${compId}`);
        // setViewComplaintModal(true);
        // if (compId) {
        //     dispatch(loadSingleComplaintEscalationData(compId));
        //     setComplaintId(compId);
        // } else {
        //     setComplaintId("");
        // }
    };

    const handleCloseViewModal = () => {
        setViewComplaintModal(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleOpenAssingToModal = (compId) => {
        setAssignToModal(true);
        if (compId) {
            dispatch(loadSingleComplaintEscalationData(compId));
            setComplaintId(compId);
        } else {
            setComplaintId("");
        }
    }

    const handleEditERT = (compId) => {
        setERTModal(true);
        if (compId) {
            dispatch(loadSingleComplaintEscalationData(compId));
            setComplaintId(compId);
        } else {
            setComplaintId("");
        }
    }

    const handleCloseAssignToModal = () => {
        setAssignToModal(!showAssignToModal);
    }
    const handleCloseERTModal = () => {
        setERTModal(!showERTModal);
    }
    const navigate = useNavigate();
    const handleAnalyticsClick = () => {
        navigate('/complaintDashboard')
    }

    const handleOpenAttachmentUploadModal = () => {
        // Reset the state before opening the modal
        setDroppedFile(null);
        setFiles([]);
        setProgress([]);
        setUploadComplete(false);
        setShowAttachmentUploadModal(true);
    };

    const handleCloseBulkUploadModal = () => {
        setShowAttachmentUploadModal(false);
        // Reset states when closing the modal if needed
        setDroppedFile(null);
        setFiles([]);
        setProgress([]);
        setUploadComplete(false);
    };

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        processFiles(newFiles);
    };

    const validFileTypes = ['image/jpeg', 'image/png', 'image/jpg']; // Allowed file types
    const maxFiles = 5; // Maximum number of files

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const newFiles = Array.from(event.dataTransfer.files);
        console.log('Dropped files:', newFiles);

        // Check for duplicates and validate file types
        const existingFiles = new Set(files.map(file => file.name));
        const uniqueFiles = newFiles.filter(file => {
            const isValidType = validFileTypes.includes(file.type);
            const isDuplicate = existingFiles.has(file.name);
            return isValidType && !isDuplicate;
        });

        console.log('Unique files to be added:', uniqueFiles);

        // Check if adding these files exceeds the limit
        if (files.length + uniqueFiles.length > maxFiles) {
            alert(`You can only upload a maximum of ${maxFiles} files.`);
            return;
        }

        if (uniqueFiles.length > 0) {
            processFiles(uniqueFiles);
        }
    };

    const processFiles = (newFiles) => {
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        setProgress((prevProgress) => [
            ...prevProgress,
            ...newFiles.map(() => 0)
        ]);
        simulateProgress(newFiles.length);
    };

    const simulateProgress = (newFileCount) => {
        const currentFileIndex = files.length;
        for (let i = 0; i < newFileCount; i++) {
            let progressValue = 0;
            const interval = setInterval(() => {
                if (progressValue >= 100) {
                    clearInterval(interval);
                    setUploadComplete(true); // Set completion status
                    return;
                }
                progressValue += 10;
                setProgress((prevProgress) => {
                    const newProgress = [...prevProgress];
                    newProgress[currentFileIndex + i] = progressValue;
                    return newProgress;
                });
            }, 500);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation(); // Stop the event from bubbling up
    };

    const removeFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        setProgress((prevProgress) => prevProgress.filter((_, i) => i !== index));
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    // const handleStatusChange = (customer, statusLabel) => {
    //     const statusMapping = {
    //         "Pending": 36,
    //         "In-Process": 37,
    //         "Resolved": 38,
    //         "Re-Open": 39,
    //         "Cancel": 40,
    //     };

    //     const statusID = statusMapping[statusLabel]; // Get the status ID from the mapping
    //     if (!statusID) {
    //         console.error("Invalid status label:", statusLabel);
    //         return;
    //     }

    //     console.log(customer, 'customer')
    //     const data = {
    //         ComplaintID: customer.ComplaintsID,
    //         TicketType: customer.TicketType,
    //         CompanyID: customer.CompanyID,
    //         ReportedByUserID: customer.ReportedByUserID,
    //         BranchID: customer.BranchID,
    //         Priority: customer.Priority,
    //         IssueTypeID: customer.IssueTypeID,
    //         Email: customer.Email,
    //         ContactNo: customer.ContactNo,
    //         ZIPCode: customer.ZIPCode,
    //         Address: customer.Address,
    //         AssignedToUserID: customer.AssignedToUserID,
    //         TATInDays: customer.TATInDays,
    //         UserUploadedFileName: customer.AttachedFileName,
    //         // TempFileName: customer,
    //         Remarks: customer.Remarks,
    //         StatusID: statusID,
    //         AddedByID: ADDED_BY_ID
    //     };

    //     let requestOption = {
    //         method: "POST",
    //         mode: "cors",
    //         headers: HeaderAuthentication.postExcomatixAuth,
    //         body: JSON.stringify(data),
    //     };

    //     // Dispatch the action to update the department status
    //     dispatch(postComplaintEscalationDatas(requestOption, handleCloseModal, getComplaintData, customer.ComplaintsID));
    //     // console.log(data, 'data'); // For debugging purposes
    // };
    const handleStatusChange = (customer, statusLabel) => {
        const statusMapping = {
            "Pending": 36,
            "In-Process": 37,
            "Resolved": 38,
            "Re-Open": 39,
            "Cancelled": 40,
        };

        const statusID = statusMapping[statusLabel]; // Get the status ID from the mapping
        if (!statusID) {
            console.error("Invalid status label:", statusLabel);
            return;
        }

        console.log(customer, 'customer')
        const data = {
            ComplaintID: customer.ComplaintsID,
            StatusID: statusID,
            AddedByID: JSON.stringify(ADDED_BY_ID)
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postComplaintEscalationStatusChangeDatas(requestOption, handleCloseModal, getComplaintData, customer.ComplaintsID));
        // console.log(data, 'data'); // For debugging purposes
    };

    const handleCancelStatus = (customer) => {
        const updatedDetails = {
            ComplaintID: customer.ComplaintsID,
            StatusChangeUserUploadedFileName: '',
            StatusChangeTempFileName: '',
            StatusID: 40,
            StatusChangeRemarks: '',
            AddedByID: ADDED_BY_ID,
        };

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(updatedDetails),
        };

        dispatch(postComplaintEscalationStatusChangeDatas(requestOption, handleCloseModal, getComplaintData));
    };

    const handleSearchClick = () => {
        getComplaintData(searchText);
    };

    const handleClearFilters = () => {
        setSearchText("");
        setFromDate(null);
        setToDate(null);
        setStatusID(null);
        setTicketType(null);
        getComplaintData();
    }

    const handleFileDownload = (customer) => {
        console.log(customer, 'customer')

        if (customer.ComplaintsID && customer.AttachedFileName) {
            // Format the URL with query parameters
            const url = `${baseURL}/complaintservices/api/Complaint/DownloadFile?ComplaintID=${customer.ComplaintsID}&FileName=${encodeURIComponent(customer.AttachedFileName)}`;

            // Make the GET request
            fetch(url, HeaderAuthentication.getRequestOptions)
                .then((resp) => resp.blob()) // Assuming the file is returned as a Blob
                .then((blob) => {
                    // Create a link to download the file
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = customer.AttachedFileName; // Set the file name for download
                    link.click(); // Trigger the download
                })
                .catch((err) => {
                    console.error("File download failed:", err);
                });
        } else {
            console.error("Invalid file data");
        }

    }

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = complainEscalationData?.map(item => ({
            "Complaint No": item.ComplaintsID || "NA",
            "Ticket Type": item.TicketType || "NA",
            "Date": item.ReportedDate || "NA",
            "Company": item.CompanyName || "NA",
            "Reported By": item.ReportedByUser || "NA",
            "Branch": item.BranchName || "NA",
            "Email": item.Email || "NA",
            "Contact": item.ContactNo || "NA",
            "Priority": item.Priority || "NA",
            "Assigned To": item.AssignedToUser || "NA",
            "TAT": item.TATInDays || "NA",
            "Issue Type": item.IssueType || "NA",
            "Status": item.Status || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Complaints");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'complain_escaltions.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("Complaint Escalation Data", 14, 20);

        const dataToExport = complainEscalationData?.map(item => ([
            item.ComplaintsID || "NA",
            item.TicketType || "NA",
            item.ReportedDate || "NA",
            item.CompanyName || "NA",
            item.ReportedByUser || "NA",
            item.BranchName || "NA",
            item.Email || "NA",
            item.ContactNo || "NA",
            item.Priority || "NA",
            item.AssignedToUser || "NA",
            item.TATInDays || "NA",
            item.IssueType || "NA",
            item.Status || "NA",
        ])) || [];

        const columns = [
            { title: "Complaint No", dataKey: "complaintNo" },
            { title: "Ticket Type", dataKey: "ticketType" },
            { title: "Date", dataKey: "date" },
            { title: "Company", dataKey: "company" },
            { title: "Reported By", dataKey: "reportedBy" },
            { title: "Branch", dataKey: "branch" },
            { title: "Email", dataKey: "email" },
            { title: "Contact", dataKey: "contact" },
            { title: "Priority", dataKey: "priority" },
            { title: "Assigned To", dataKey: "assignedTo" },
            { title: "TAT", dataKey: "tat" },
            { title: "Issue Type", dataKey: "issueType" },
            { title: "Status", dataKey: "status" }
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'center',
            },
        });

        // Save PDF
        doc.save('complain_escalations.pdf');
    };

    const handleDownloadWord = () => {
        if (!complainEscalationData || complainEscalationData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = complainEscalationData.map(item => [
            String(item?.ComplaintsID || "NA"),  // Explicitly convert to string
            String(item?.TicketType || "NA"),  // Explicitly convert to string
            String(item?.ReportedDate || "NA"),  // Explicitly convert to string
            String(item?.CompanyName || "NA"),  // Explicitly convert to string
            String(item?.ReportedByUser || "NA"),  // Explicitly convert to string
            String(item?.BranchName || "NA"),  // Explicitly convert to string
            String(item?.Email || "NA"),  // Explicitly convert to string
            String(item?.ContactNo || "NA"),  // Explicitly convert to string
            String(item?.Priority || "NA"),  // Explicitly convert to string
            String(item?.AssignedToUser || "NA"),  // Explicitly convert to string
            String(item?.TATInDays || "NA"),  // Explicitly convert to string
            String(item?.IssueType || "NA"),  // Explicitly convert to string
            String(item?.Status || "NA")  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "Complaint No", "Ticket Type", "Date", "Company", "Reported By", "Branch",
            "Email", "Contact", "Priority", "Assigned To", "Estimated Resolution Time ", "Issue Type", "Status"
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "Complaint Management System",
            title: "Complaint Escalation Report",
            description: "A detailed report of complaints and escalations.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "complain_escalations.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!complainEscalationData || complainEscalationData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = complainEscalationData.map(item => [
            item?.ComplaintsID || "NA",
            item?.TicketType || "NA",
            item?.ReportedDate || "NA",
            item?.CompanyName || "NA",
            item?.ReportedByUser || "NA",
            item?.BranchName || "NA",
            item?.Email || "NA",
            item?.ContactNo || "NA",
            item?.Priority || "NA",
            item?.AssignedToUser || "NA",
            item?.TATInDays || "NA",
            item?.IssueType || "NA",
            item?.Status || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "Complaint No", "Ticket Type", "Date", "Company", "Reported By", "Branch",
            "Email", "Contact", "Priority", "Assigned To", "TAT", "Issue Type", "Status"
        ];

        // Create HTML table for printing
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a print window
        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>Complaint Escalation Report</title>');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h1>Complaint Escalation Report</h1>');
        printWindow.document.write(tableHtml); // Insert the table
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for the document to load

        // Trigger the print dialog after content is loaded
        printWindow.print();
    };

    const handleDownloadImage = () => {
        if (!complainEscalationData || complainEscalationData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = complainEscalationData.map(item => [
            item?.ComplaintsID || "NA",
            item?.TicketType || "NA",
            item?.ReportedDate || "NA",
            item?.CompanyName || "NA",
            item?.ReportedByUser || "NA",
            item?.BranchName || "NA",
            item?.Email || "NA",
            item?.ContactNo || "NA",
            item?.Priority || "NA",
            item?.AssignedToUser || "NA",
            item?.TATInDays || "NA",
            item?.IssueType || "NA",
            item?.Status || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "Complaint No", "Ticket Type", "Date", "Company", "Reported By", "Branch",
            "Email", "Contact", "Priority", "Assigned To", "TAT", "Issue Type", "Status"
        ];

        // Create the table HTML to be rendered
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a container div for the table to be captured
        const printContainer = document.createElement('div');
        printContainer.innerHTML = tableHtml;

        // Append the print container to the body (for rendering purposes)
        document.body.appendChild(printContainer);

        // Use html2canvas to convert the table HTML into an image
        html2canvas(printContainer, {
            scale: 2, // Increase the scale to get better image quality (default is 1)
            useCORS: true, // Enable Cross-Origin Resource Sharing (useful if the table includes external images)
            width: printContainer.scrollWidth, // Dynamically set the width of the canvas to fit the content
            height: printContainer.scrollHeight, // Dynamically set the height of the canvas to fit the content
            scrollX: 0, // Ensure that it doesn't pick up the page's scroll position
            scrollY: -window.scrollY // Adjust the scroll position if necessary
        }).then(canvas => {
            // Remove the print container after rendering
            document.body.removeChild(printContainer);

            // Convert canvas to image data URL
            const imgData = canvas.toDataURL('image/png');

            // Create a temporary link to trigger download
            const link = document.createElement('a');
            link.href = imgData;
            link.download = 'complaint_escalation_report.png'; // Specify the image file name
            link.click(); // Simulate a click event to trigger the download
        });
    };

    return (
        <div className="customer-management-container">
            {!showCustomerViewDetails && <Main>
                <div className='components-download-container'>
                    <Download
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={true}
                        showDownloadDropdown={true}
                        onClick={handleAnalyticsClick}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Service Requests</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3} className='filters-col'>
                                    <div className='customermanagement-search'>
                                        <Form.Control
                                            type="search"
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <img src={searchIcon} alt="" className='p-2' onClick={() => { setSearchText(searchText); }} />
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            selectsStart
                                            placeholderText='From'
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            maxDate={new Date()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            selectsEnd
                                            placeholderText='To'
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            maxDate={new Date()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                {/* <div style={{ width: "100%" }}> */}
                                {/* <Col md={3} className='filters-col'> */}
                                <Select
                                    className="react-select-container complaint-status-select"
                                    classNamePrefix="react-select"
                                    placeholder="Select Status"
                                    options={statusOptions}
                                    style={{ width: "100%" }}
                                    value={statusOptions.find(option => option.value === statusID) || null}  // Pass the full option object
                                    onChange={handleStatus}
                                />
                                {/* </Col> */}
                                {/* </div> */}
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {moduleData?.CanCreate === true && <SbAddBtn btnName="Add Service Request" onClickEffect={() => { handleOpenModal("") }} />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <ComplaintEscalationTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                handleOpenViewModal={handleOpenViewModal}
                                handleOpenValueFilterModal={handleOpenValueFilterModal}
                                handleOpenAttachmentUploadModal={handleOpenAttachmentUploadModal}
                                complainEscalationData={complainEscalationData}
                                loading={loading}
                                selectedColumns={selectedColumns}
                                handleStatusChange={handleStatusChange}
                                handleFileDownload={handleFileDownload}
                                handleOpenAssingToModal={handleOpenAssingToModal}
                                getComplaintData={getComplaintData}
                                singleComplaintEscalationData={singleComplaintEscalationData}
                                moduleData={moduleData}
                                handleEditERT={handleEditERT}
                                handleCancelStatus={handleCancelStatus}
                            />
                        </div>
                    </div>
                </div>
            </Main>}
            {/* Upload Attachment Modal */}
            <Modal
                show={showAttachmentUploadModal}
                onHide={handleCloseBulkUploadModal}
                centered
                size="lg"
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                className='add-customer-modal add-user-modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Upload Attachments</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="bulkFileInput">
                        <div
                            className="drag-and-drop-area"
                            // onDragOver={(e) => e.preventDefault()}
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                        >
                            <div className='drag-drop-container'>
                                {files.length > 0 ? (
                                    files.map((file, index) => (
                                        <div key={index} className="file-info">
                                            <span>{file.name}</span>&nbsp;&nbsp;
                                            <ProgressBar
                                                now={progress[index] || 0}
                                                label={`${progress[index] || 0}%`}
                                                variant={progress[index] === 100 ? "success" : "danger"}
                                            />
                                            <div className='d-flex justify-content-between align-items-center pt-2'>
                                                <p> ({(file.size / (1024 * 1024)).toFixed(2)} MB)</p>
                                                <p style={{ color: progress[index] === 100 ? "green" : "red" }}>
                                                    {progress[index] === 100 ? "Completed" : "Loading..."}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className='drag-drop-div'>
                                        <p>Drag & Drop files(Supports only JPG,JPEG,PNG)</p>
                                    </div>
                                )}
                            </div>
                            <div className='browse-btn-div'>
                                <SBSaveUpdateBtn btnName="Browse Files" onClickEffect={() => fileInputRef.current.click()} />
                                <input
                                    type="file"
                                    multiple
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    accept=".jpg,.jpeg,.png"
                                />
                            </div>
                        </div>
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={handleCloseBulkUploadModal} />
                    <SBSaveUpdateBtn btnName="Upload Attachment" />
                </Modal.Footer>
            </Modal>
            {
                isModalOpen && <AddComplaintEsaclation
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    getComplaintData={getComplaintData}
                    complaintId={complaintId}
                    singleComplaintEscalationData={singleComplaintEscalationData}
                />
            }
            {
                viewComplaintModal && <ViewComplaints
                    viewComplaintModal={viewComplaintModal}
                    handleCloseViewModal={handleCloseViewModal}
                    singleComplaintEscalationData={singleComplaintEscalationData}
                    handleAnalyticsClick={handleAnalyticsClick}
                />
            }
            {showColumnFilterModal && (
                <ComplaintColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {showValueFilterModal && (
                <ComplaintValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                    setLoading={setLoading}
                />
            )}
            {showAssignToModal && (
                <AssignToComplaintModal
                    showAssignToModal={showAssignToModal}
                    handleCloseAssignToModal={handleCloseAssignToModal}
                    complaintId={complaintId}
                    getComplaintData={getComplaintData}
                    singleComplaintEscalationData={singleComplaintEscalationData}
                />
            )}
            {showERTModal && (
                <UpdateERT
                    showERTModal={showERTModal}
                    handleCloseERTModal={handleCloseERTModal}
                    complaintId={complaintId}
                    getComplaintData={getComplaintData}
                    singleComplaintEscalationData={singleComplaintEscalationData}
                />
            )}
            {/* {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default ComplaintEscalation;